import React, { useMemo } from 'react';
import useLoadFBScript from './hooks/useLoadFBScript';
import { FacebookOAuthContext } from './context';

export default function FacebookOAuthProvider({
    appId,
    nonce,  
    onScriptLoadSuccess,
    onScriptLoadError,
    children,
}) {
    const scriptLoadedSuccessfully = useLoadFBScript({
        nonce,
        onScriptLoadSuccess,
        onScriptLoadError,
    });

    const contextValue = useMemo(() => ({
        appId,
        scriptLoadedSuccessfully,
    }), [appId, scriptLoadedSuccessfully]);

    return (
        <FacebookOAuthContext.Provider value={contextValue}>
            {children}
        </FacebookOAuthContext.Provider>
    );
}


